import {
  RESET_RESERVATION_AVAILABILITY,
  RESERVATION_AVAILABILITY_REQUESTING,
  LIST_RESERVATION_AVAILABILITIES_SUCCESS,
  RESET_RESERVATION_AVAILABILITY_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  query: null,
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_RESERVATION_AVAILABILITY: {
      return {
        ...state,
        data: null,
        query: null
      };
    }
    case RESET_RESERVATION_AVAILABILITY_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESERVATION_AVAILABILITY_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_RESERVATION_AVAILABILITIES_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        data,
        query,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
